import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="bg-gray-900 text-white py-20 md:py-28 px-4 border-t border-gray-800" data-id="element-76">
      <div className="max-w-3xl mx-auto" data-id="element-77">
        <h2 className="text-3xl md:text-5xl font-bold text-center mb-12" data-id="element-78">
          FAQ for Men Who Value Their Time
        </h2>

        <div className="space-y-4" data-id="element-79">
          {/* FAQ 1 */}
          <div className="bg-gray-800 border border-gray-700 rounded-xl overflow-hidden transition-all duration-200" data-id="element-80">
            <button onClick={() => toggleFAQ(0)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" aria-expanded={openIndex === 0} data-id="element-81">
              <span className="font-bold text-lg" data-id="element-82">How long does it take?</span>
              <ChevronDownIcon className={`w-5 h-5 text-amber-500 transition-transform duration-300 ${openIndex === 0 ? 'rotate-180' : ''}`} data-id="element-83" />
            </button>
            <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === 0 ? 'max-h-40 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-84">
              <p className="text-gray-300" data-id="element-85">
                15 mins a day. We designed this specifically for busy
                executives, business owners, and fathers who don't have 2 hours
                to spend in a gym.
              </p>
            </div>
          </div>

          {/* FAQ 2 */}
          <div className="bg-gray-800 border border-gray-700 rounded-xl overflow-hidden transition-all duration-200" data-id="element-86">
            <button onClick={() => toggleFAQ(1)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" aria-expanded={openIndex === 1} data-id="element-87">
              <span className="font-bold text-lg" data-id="element-88">Is it safe?</span>
              <ChevronDownIcon className={`w-5 h-5 text-amber-500 transition-transform duration-300 ${openIndex === 1 ? 'rotate-180' : ''}`} data-id="element-89" />
            </button>
            <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === 1 ? 'max-h-40 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-90">
              <p className="text-gray-300" data-id="element-91">
                100% Natural. No drugs, no TRT prescriptions, no sketchy
                supplements. This is about optimizing your body's natural
                biological processes.
              </p>
            </div>
          </div>

          {/* FAQ 3 */}
          <div className="bg-gray-800 border border-gray-700 rounded-xl overflow-hidden transition-all duration-200" data-id="element-92">
            <button onClick={() => toggleFAQ(2)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" aria-expanded={openIndex === 2} data-id="element-93">
              <span className="font-bold text-lg" data-id="element-94">Will it work if I'm 60?</span>
              <ChevronDownIcon className={`w-5 h-5 text-amber-500 transition-transform duration-300 ${openIndex === 2 ? 'rotate-180' : ''}`} data-id="element-95" />
            </button>
            <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === 2 ? 'max-h-40 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-96">
              <p className="text-gray-300" data-id="element-97">
                Yes, your biology is ready for a reset. The principles of
                hormonal optimization apply whether you are 40, 50, or 65.
              </p>
            </div>
          </div>

          {/* FAQ 4 */}
          <div className="bg-gray-800 border border-gray-700 rounded-xl overflow-hidden transition-all duration-200" data-id="element-98">
            <button onClick={() => toggleFAQ(3)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" aria-expanded={openIndex === 3} data-id="element-99">
              <span className="font-bold text-lg" data-id="element-100">Is the price real?</span>
              <ChevronDownIcon className={`w-5 h-5 text-amber-500 transition-transform duration-300 ${openIndex === 3 ? 'rotate-180' : ''}`} data-id="element-101" />
            </button>
            <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === 3 ? 'max-h-40 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-102">
              <p className="text-gray-300" data-id="element-103">
                Yes, but only for the first 50 buyers today. We are offering
                this massive discount to gather more success stories and
                testimonials before raising it to the regular $197 price.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}